<template>
  <div class="home-container">
    <nuxt-child></nuxt-child>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  created() {
    if (process.client) {
      this.$hive.initHive();
      this.$hive.send('010012002');

      if (window.document.title !== this.$t('lang181')) {
        // must
        window.document.title = this.$t('lang181');
      }
    }
  },
  head() {
    return {
      title: this.$t('lang181'),
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.$t('lang181')
        },
        {
          hid: 'description',
          name: 'description',
          content: this.$t('lang182')
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.$t('lang182')
        }
        // {
        //   hid: 'og:image',
        //   property: 'og:image',
        //   content: 'https://giftesx.bigo.sg/live/3s4/2IUT4u.jpg'
        // }
      ]
    };
  }
};
</script>
<style lang="scss" scoped>
.home-container {
  margin: 0 auto;
}
</style>
